import { Tabs } from "antd";
import React from "react";
import { STATUSES } from "../../../data/statuses";
import LeadCard from "./LeadCard";

export default function MobileBoard({ leads, onMove }) {
  return (
    <Tabs>
      {STATUSES.map((s) => (
        <Tabs.TabPane tab={s.title} key={s.key}>
          {leads
            .filter((l) => l.status === s.key)
            .map((l) => (
              <LeadCard key={l.id} lead={l} onMove={onMove} />
            ))}
        </Tabs.TabPane>
      ))}
    </Tabs>
  );
}
